import Delete from "@src/icons/Delete";
import styled from "styled-components";

export const DeleteCodeButtonIcon = styled(Delete)`
    && {
        width: 12px;
        height: 12px;
        margin-right: 5px;
    }
`;
